export const getSocketConfig = () => {
  const storeInit = JSON.parse(sessionStorage.getItem("soketVariable")) ?? [];
  return {
    di: storeInit?.UFCC ?? '',
    address: storeInit?.Socket_URL ?? '',
    SoPath: storeInit?.Socket_Path ?? '',
  };
};
